import axios from 'axios'

//export const API_URL = "https://local.officefinder.pl/flexhub/api"
export const API_URL = "https://www.officefinder.pl/flexhub/api"

const headers = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',
  'Authorization': token
}

// Generate a unique token for storing your bookshelf data on the backend server.
let token = localStorage.token
if (!token)
  token = localStorage.token = Math.random().toString(36).substr(-8)

const initialState = {
	authedUser: {},
	enquiries: {},
	offices: {}
}

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('state');

    if (serializedState === null) {
    	const state = JSON.stringify(initialState)
    	saveState(state)

      return initialState
    }
    return JSON.parse(serializedState);

  } catch (err) {
    return undefined;
  }
}

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('state', serializedState);
  } catch (err) {
    // ignore write errors
  }
}

export function getInitialData (userHashId) {
  return Promise.all([
    getEnquiries(userHashId),
    getOffices(userHashId),
    getUsers(userHashId),
    getUserByHashId(userHashId)
  ]).then(([enquiries, offices, users, authedUser]) => ({
    enquiries,
    offices,
    users,
    authedUser
  }))
}

export const getEnquiries = (userHashId) =>
	axios.get(`${API_URL}/enquiries/${userHashId}`)
    .then(res => res.data)

export const getOffices = (userHashId) =>
	axios.get(`${API_URL}/offices/${userHashId}`)
    .then(res => res.data)

export const getUser = (username, password) =>
	axios.post(`${API_URL}/signIn`, JSON.stringify({username, password}))
    .then(res => res.data)

export const createAccount = (data) =>
  axios.post(`${API_URL}/createAccount`, JSON.stringify(data))
    .then(res => res.data)

export const getUserByHashId = (userHashId) =>
	axios.post(`${API_URL}/user/${userHashId}`)
    .then(res => res.data)

export const getEnquiry = (enquiryId) =>
	axios.get(`${API_URL}/enquiry/${enquiryId}`)
    .then(res => res.data)

export const changeEnquiryStatus = (id, statusId, userId) =>
	axios.post(`${API_URL}/enquiry/changeStatus`, JSON.stringify({id, statusId, userId}))
		.then(res => res.data)

export const saveEnquiryData = (enquiryId, data, userId) =>
  axios.post(`${API_URL}/enquiry/saveEnquiryData`, JSON.stringify({enquiryId, data, userId}))
    //.then(res => res.data)

export const saveOfficeData = (officeId, data, userId) =>
  axios.post(`${API_URL}/office/saveOfficeData`, JSON.stringify({officeId, data, userId}))
    .then(res => res.data)

export const savePackets = (officeId, packetData) =>
  axios.post(`${API_URL}/office/savePackets`, JSON.stringify({officeId, packetData}))
    //.then(res => res.data)

export const savePacket = (packetData) =>
  axios.post(`${API_URL}/office/savePacket`, packetData)
    .then(res => res.data)

export const addPacket = (packetData) =>
  axios.post(`${API_URL}/office/addPacket`, packetData)
    .then(res => res.data)

export const deletePacket = (id) =>
  axios.post(`${API_URL}/office/deletePacket`, JSON.stringify({id}))

export const getOffice = (officeId) =>
	axios.get(`${API_URL}/office/${officeId}`)
    .then(res => res.data)

export const uploadPhotos = (data) =>
  axios.post(`${API_URL}/office/uploadPhotos`, data)
    .then(res => res.data)

export const savePhotoData = (officeId, data, userId) =>
  axios.post(`${API_URL}/office/savePhotoData`, JSON.stringify({officeId, data, userId}))
    .then(res => res.data)

export const deletePhoto = (officeId, photoId, userId) =>
  axios.post(`${API_URL}/office/deletePhoto`, JSON.stringify({officeId, photoId, userId}))
    .then(res => res.data)

export const logOfficeUpdate = (officeId, userId) =>
  axios.post(`${API_URL}/office/logOfficeUpdate`, JSON.stringify({officeId, userId}))
    .then(res => res.data)

export const getViews = (accountId) =>
	axios.get(`${API_URL}/account/views/${accountId}`)
    .then(res => res.data)

export const getEnquiriesStatistics = (accountId) =>
	axios.get(`${API_URL}/account/enquiries/${accountId}`)
    .then(res => res.data)

export const getUsers = (userHashId) =>
  axios.get(`${API_URL}/users/${userHashId}`)
    .then(res => res.data)

export const saveProfileData = (userId, data) =>
  axios.post(`${API_URL}/account/saveProfileData`, JSON.stringify({userId, data}))
    .then(res => res.data)

export const updateProfilePassword = (userId, data) =>
  axios.post(`${API_URL}/account/updateProfilePassword`, JSON.stringify({userId, data}))
    .then(res => res.data)

export const forgotPassword = (username) =>
  axios.post(`${API_URL}/forgotPassword`, JSON.stringify({username}))
    .then(res => res.data)

export const resetPassword = (hashId, password) =>
  axios.post(`${API_URL}/resetPassword`, JSON.stringify({hashId, password}))
    .then(res => res.data)

export const saveUserData = (userId, data) =>
  axios.post(`${API_URL}/user/saveUserData`, JSON.stringify({userId, data}))
    .then(res => res.data)

export const addUserData = (data) =>
  axios.post(`${API_URL}/user/addUser`, JSON.stringify({data}))
    .then(res => res.data)

export const deleteUserData = (userId) =>
  axios.post(`${API_URL}/user/deleteUser`, JSON.stringify({userId}))

export const updateUserPassword = (userId, password) =>
  axios.post(`${API_URL}/user/updateUserPassword`, JSON.stringify({userId, password}))
    //.then(res => res.data)

export const updateUserAvatar = (data) =>
  axios.post(`${API_URL}/user/updateUserAvatar`, data)
    .then(res => res.data)

export const saveAssignedBuildings = (userId, assignedBuildings) =>
  axios.post(`${API_URL}/user/saveAssignedBuildings`, JSON.stringify({userId, assignedBuildings}))
    .then(res => res.data)

export const acceptRegulationsByUser = (userId) =>
  axios.post(`${API_URL}/account/acceptRegulations/${userId}`)
    //.then(res => res.data)


// WEBPACK FOOTER //
// ./src/utils/api.js